import { defineStore } from 'pinia'
import { useCustomerStore } from 'src/stores/customer'
import { useAuthStore } from 'src/stores/auth'
import { useCartStore } from 'src/stores/cart'
import { usePersistedStore } from 'src/stores/persisted'
import { useCommonStore } from 'src/stores/common'
import { encryptStorage } from 'src/utils/pinia-encryption'

export const useAgeVerificationStore = defineStore('ageVerification', {
  state: () => ({
    isVerificationSuccess: false,
    isVerificationFail: false,
    showVeirificationPopup: true,
    loading: false,
    cartNumber: null,
    skipBrowsingAgeRestrictedProd: null,
  }),
  getters: {
    isOrderVerified(state) {
      const cartStore = useCartStore()
      return !!(
        state.cartNumber && state.cartNumber == cartStore.currentCartNumber
      )
    },
    isUserAgeVerified() {
      const authStore = useAuthStore()
      const isLoggedIn = authStore.isLoggedIn,
        customerStore = useCustomerStore(),
        persistedStore = usePersistedStore()

      return !!(
        (!isLoggedIn && persistedStore.eaivPersistedVerificationSuccess) ||
        (isLoggedIn && customerStore?.customer?.isVerifiedOnline)
      )
    },
    showAgeVerificationBtn() {
      const commonStore = useCommonStore()
      let businessConfigurations = commonStore.businessConfigurations

      return (
        businessConfigurations?.isStoreAgeRestricted &&
        (businessConfigurations.enableAgeRestrictedBrowsing ||
          (businessConfigurations.enableAgeRestrictedCheckout &&
            (this.skipBrowsingAgeRestrictedProd ||
              this.skipBrowsingAgeRestrictedProd == null))) &&
        !this.isUserAgeVerified
      )
    },
    storeHasAgeRestriction() {
      const commonStore = useCommonStore()
      let businessConfigurations = commonStore.businessConfigurations
      return (
        businessConfigurations?.isStoreAgeRestricted &&
        (businessConfigurations.enableAgeRestrictedBrowsing ||
          businessConfigurations.enableAgeRestrictedCheckout)
      )
    },
  },
  actions: {
    async sendPersonalInfo(body) {
      try {
        const persistedStore = usePersistedStore()
        let { data } = await this.$axiosInstance.post('/AgeVerification', body)

        if (data.success && data.data?.sessionId) {
          persistedStore.setField({
            field: 'eaivPersistedSessionId',
            value: data.data.sessionId,
          })
        }
        return data
      } catch (error) {
        return error
      }
    },
    async checkStatus(sessionId) {
      try {
        let { data } = await this.$axiosInstance.get(
          `/AgeVerification/Session/Status/${sessionId}`
        )

        return data
      } catch (error) {
        return error
      }
    },
    async verificationComplete({ sessionId, params }) {
      try {
        let { data } = await this.$axiosInstance.post(
          `/AgeVerification/Complete/${sessionId}`,
          {},
          { params }
        )

        return data
      } catch (error) {
        return error
      }
    },
    async verificationHistory(body) {
      try {
        let { data } = await this.$axiosInstance.post(
          '/AgeVerification/Verification/History',
          body
        )

        return data
      } catch (error) {
        return error
      }
    },
    setLoading(loading) {
      this.loading = loading
    },
    setField({ field, value }) {
      this[field] = value
    },
    resetVerificationStatus() {
      this.isVerificationSuccess = false
      this.isVerificationFail = false
    },
    setVerificationStatus(isSuccess) {
      if (isSuccess) this.isVerificationSuccess = true
      else this.isVerificationFail = true
    },
  },
  // persist: true,
  persist: {
    storage: encryptStorage,
  },
})
